// The Trustpilot script src is added to the body in the startRNXTInstance
import { memo } from 'react'
import { RaContainer } from '@components/core/index.core'
import { RaTrustpilot } from '@components/features/RaTrustpilot/RaTrustpilot'

import type { AcfTrustpilotProps } from '@typings'

export const AcfTrustpilot = memo((props: AcfTrustpilotProps) => {
  return (
    <RaContainer>
      <RaTrustpilot html={props.trustpilot} />
    </RaContainer>
  )
})
